<template>
  <div class="ui container" style="text-align: center;">
    Enter the number you're buying for.
    <div>
      <label>+63&nbsp;&nbsp;&nbsp;</label>
      <input type="tel" placeholder="949 871 9362" v-model="phoneNumber"/>
    </div>
    <div class="button-div">
      <button class="ui fluid primary button" @click="proceedToNext">
        Proceed
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputNumber',
  data () {
    return {
      phoneNumber: ''
    }
  },
  methods: {
    proceedToNext () {
      console.log(this.fullPhoneNumber)

      this.$router.push({
        name: 'SelectLoadType',
        params: { phone_number: this.fullPhoneNumber }
      })
    }
  },
  computed: {
    fullPhoneNumber () {
      return `0${this.phoneNumber}`
    }
  }
}
</script>

<style scoped>
  label {
    display: inline-block;
    border-bottom: 1px solid gray;
    margin-right: -5px;
    padding: 3px;
  }

  input[type=tel] {
    border-right: 0;
    border-top: 0;
    border-bottom: 1px solid gray;
    outline: none;
    padding: 4px;
  }

  .button-div {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BuyLoad/InputNumber.vue